<template>
  <v-container>
    <v-card class="pa-4" shaped>
      <v-card-title>Registeration</v-card-title>
      <!-- <v-card-title class="subtitle-2">Winners</v-card-title> -->
      <v-card-text>
        <v-row class="mb-3">
          <v-col cols="12" xs="12" sm="4">
            <v-text-field
              v-model="search"
              outlined
              rounded
              dense
              append-icon="mdi-magnify"
              @click:append="searchInput"
              clearable
              label="Search Email"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col>
            <div>
              <!-- <div class="red"> -->
              <v-menu top close-on-click>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" class="mr-2" rounded dark v-on="on">{{
                    dateRangeText
                  }}</v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in menuItems"
                    :key="index"
                    @click="itemSelected(item)"
                  >
                    <v-list-item-title>{{ item.display }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                :return-value.sync="dates"
                transition="scale-transition"
                top
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on"></div>
                </template>
                <v-date-picker v-model="dates" range scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dateMenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn text color="primary" @click="setRange">OK</v-btn>
                </v-date-picker>
              </v-menu>
              <!-- </div> -->
            </div>
          </v-col>
        </v-row>
        <v-data-table
          :headers="header"
          :search="search"
          :items="transactions"
          :server-items-length="count"
          :loading="loading"
          class="elevation-0"
          v-on:update:options="getOptions"
        >
          <template v-slot:item.amount="{ item }">
            <v-chip
              small
              light
              outlined
              color="blue"
              class="font-weight-bold"
              >{{ formartCurrency(item.amount, false, true) }}</v-chip
            >
          </template>
          <template v-slot:item.remainingDraws="{ item }">
            <v-chip
              small
              light
              outlined
              color="green"
              class="font-weight-bold"
              >{{ item.remainingDraws }}</v-chip
            >
          </template>
          <template v-slot:item.completedDraws="{ item }">
            <v-chip
              small
              light
              outlined
              color="orange"
              class="font-weight-bold"
              >{{ item.completedDraws ? item.completedDraws : 0 }}</v-chip
            >
          </template>
          <template v-slot:item.createdAt="{ item }">
            <div class="txt">
              {{ formatDateMed(item.createdAt) }} :
              {{ formatTime(item.createdAt) }}
            </div>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon class="mr-5" color="primary" @click="showDetail(item)"
              >mdi-open-in-new</v-icon
            >
          </template>

          <template v-slot:item.status="{ item }">
            <v-icon v-if="item.status === 'pending'" color="red"
              >mdi-alarm</v-icon
            >
            <v-icon v-else color="green">mdi-check-bold</v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" width="580">
      <RegDetail ref="dialog" v-on="handlers" />
    </v-dialog>
  </v-container>
</template>

<script>
import RegDetail from "./regDetails.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { RegDetail },
  data() {
    return {
      handlers: {
        "close-dialog": this.closeDiag,
        refresh: this.refresh,
      },

      last: ["none"],
      lastPage: 0,
      dialog: false,
      loading: false,
      options: null,
      search: null,
      dates: ["2019-09-10", "2019-09-20"],
      menu: false,
      dateMenu: false,
      datesForDisplay: null,
      // options: null,
      // search: null,
      startDate: null,
      stopDate: null,
      // dialog: false,
      selected: { display: "This Month", id: "month" },
      menuItems: [
        { display: "Today", id: "today" },
        { display: "This Week", id: "week" },
        { display: "This Month", id: "month" },
        { display: "This Quarter", id: "quarter" },
        { display: "This Year", id: "year" },
        { display: "Range Select", id: "range" },
        { display: "All", id: "all" },
      ],
      header: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "email",
        },
        {
          text: "Phone",
          align: "left",
          sortable: false,
          value: "phone",
        },
        {
          text: "Date/Time",
          align: "left",
          sortable: false,
          value: "createdAt",
        },

        {
          text: "",
          align: "left",
          value: "action",
          sortable: false,
        },
      ],
      itemsPerPage: 10,
      currentPage: 0,
      count: 0,
      sortby: "name",
      sortDesc: true,
      transactions: [],
    };
  },
  created: function () {
    // console.log("---<>", this.game);
    // setTimeout(() => {
    //   this.$refs.receiptIframe.setAttribute("src", "/receipt.html");
    // }, 3000);
  },
  computed: {
    ...mapGetters([
      "formatTime",
      "formatDateMed",
      "formartCurrency",
      "formatDateLong",
      "getEndDate",
      "formatDateRelative",
      "getDayStartAndEnd",
      "getSortedDates",
    ]),
    dateRangeText() {
      switch (this.selected.id) {
        case "range":
          if (this.datesForDisplay === 1) {
            return this.datesForDisplay;
          } else {
            return `${this.datesForDisplay[1]} to ${this.datesForDisplay[0]}`;
          }

        default:
          return this.selected.display;
      }
    },
  },
  methods: {
    ...mapActions("api", ["httpGet"]),
    ...mapActions(["showMessage"]),
    refresh() {
      this.getOptions(this.options);
      this.dialog = false;
    },
    closeDiag() {
      this.dialog = false;
    },
    showDetail(item) {
      this.dialog = true;
      setTimeout(() => {
        this.$refs.dialog.wModel = item;
      }, 100);
    },
    searchInput() {
      this.options.search = this.search.trim();
      this.getOptions(this.options);
    },
    itemSelected(item) {
      this.selected = item;
      if (item.id === "range") {
        this.dates = [new Date().toISOString().substr(0, 10)];
        this.datesForDisplay = this.dates;
        this.dateMenu = true;
        return;
      }
      let end = this.getEndDate(item.id); //this.stopDate;
      this.dates = [
        new Date().toISOString().substr(0, 10),
        end.toISOString().substr(0, 10),
      ];
      if (item.id === "all") {
        this.options.start = "all";
        this.options.end = "all";
      } else {
        this.options.start = new Date();
        this.options.end = end;
      }
      try {
        this.getOptions(this.options);
      } catch (error) {
        this.showMessage({ text: error.message, error: true });
      }
    },
    setRange() {
      if (!this.dates || this.dates.length < 1) {
        return;
      }
      let start, end;
      if (this.dates.length == 1) {
        let resp = this.getDayStartAndEnd(new Date(this.dates[0]));
        start = resp.start;
        end = resp.end;
      } else {
        let dates = this.getSortedDates([
          new Date(this.dates[0]),
          new Date(this.dates[1]),
        ]);
        start = dates.start;
        end = dates.end;
      }
      this.dates = [
        start.toISOString().substr(0, 10),
        end.toISOString().substr(0, 10),
      ];

      this.datesForDisplay = this.dates;
      this.options.start = start;
      this.options.end = end;
      try {
        this.getOptions(this.options);
        this.dateMenu = false;
      } catch (error) {
        this.showMessage({ text: error.message, error: true });
      }
    },
    getOptions: async function (options) {
      this.options = options;
      this.loading = true;
      try {
        if (this.search) {
          this.options.search = this.search.trim();
        }
        // this.options.start = this.startDate;
        // this.options.end = this.stopDate;
        if (this.options.start !== "all") {
          if (!this.options.start || !this.options.end) {
            this.options.start = new Date();
            this.options.end = this.getEndDate("month");
          }
          this.dates = [
            new Date().toISOString().substr(0, 10),
            this.options.end.toISOString().substr(0, 10),
          ];
        }
        this.itemsPerPage = options.itemsPerPage;
        this.currentPage = options.page - 1;
        this.sortby =
          options.sortBy.length === 0 ? "createdAt" : options.sortBy[0];
        this.sortDesc =
          options.sortDesc.length === 0 ? true : options.sortDesc[0];
        this.search = options.search;
        let lastId = "none";
        if (this.currentPage >= this.lastPage) {
          lastId = this.last[this.currentPage];
        } else {
          lastId = this.last[this.lastPage - 1];
        }
        let resp = await this.httpGet({
          withAuth: true,
          url: "/admin/get_regs",
          data: {
            limit: this.itemsPerPage,
            page: this.currentPage,
            sortBy: this.sortby,
            sortDesc: this.sortDesc,
            search: this.search,
            end: this.options.start,
            start: this.options.end,
            last: lastId,
          },
        });

        this.lastPage = this.currentPage;
        if (resp.data.data.length) {
          this.last[this.currentPage + 1] =
            resp.data.data[resp.data.data.length - 1].id;
        }
        console.log(resp.data);
        resp.data.data.forEach((item) => {
          if (item.status) {
            // item._type = `${item.bank}/${item.channel}`;
            // item.status = item.status[0].toUpperCase() + item.status.slice(1);
            // item.game = item.game[0].toUpperCase() + item.game.slice(1);
          }
        });

        this.transactions = resp.data.data;
        this.count = resp.data.count;
        // console.log("resp", resp.data);
      } catch (error) {
        console.error(error);
        this.showMessage({
          error: true,
          text: "Could not load preview, please refresh page",
        });
      }
      this.loading = false;
    },
  },
  watch: {
    search: function (val) {
      if (!val) {
        this.options.search = this.search;
        this.getOptions(this.options);
      }
    },
  },
};
</script>

<style lang="css" scoped>
.txt {
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
}
</style>